import { marketingHomeUrl } from '../i18n';
import PaymentsModal from './PaymentsModal';
import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { logout } from '../utils/logoutUtils';
import { fetchUserInfo } from '../utils/userInfoUtils';
import { authRequest } from '../utils/loginUtils';
import '../css/TopRightUserInfo.css';
import OrganizationModal from './OrganizationModal';
import PersonalInformationModal from './PersonalInformationModal'; // Import the new modal component

function UserInfo({ authenticated, authConfig }) {
  const { t, i18n } = useTranslation();
  const [needsAuthSetup, setNeedsAuthSetup] = useState(false);
  useEffect(() => {
    if (!authenticated || !authConfig?.enabled) return;
    let cancelled = false;
    authRequest('/auth/security').then(data => {
      if (!cancelled) setNeedsAuthSetup(!data.google && data.passwordState !== 'confirmed');
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [authenticated, authConfig]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [email, setEmail] = useState('');
  const [userTier, setUserTier] = useState('');
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPersonalInfoModalOpen, setIsPersonalInfoModalOpen] = useState(false); // State for Personal Info Modal

  useEffect(() => {
    if (!authenticated) return;
    const getUserInfo = async () => {
      try {
        const { email, tier } = await fetchUserInfo();
        setEmail(email);
        setUserTier(tier);

        // Check if user has no-tier status and show alert
        if (tier === 'no-tier') {
          alert(i18n.t('account.trialExpired'));
        }
      } catch (error) {
        setEmail(i18n.t('account.emailError'));
        setUserTier(i18n.t('account.tierError'));
      } finally {
        setLoading(false);
      }
    };
    getUserInfo();
  }, [authenticated, i18n]);

  useEffect(() => {
    if (!authenticated) return;
    let plan = new URLSearchParams(window.location.search).get('plan');
    if (['individual', 'practice'].includes(plan)) setSelectedPlan(plan);
  }, [authenticated]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openPersonalInfoModal = () => setIsPersonalInfoModalOpen(true); // Open Personal Info Modal
  const closePersonalInfoModal = () => setIsPersonalInfoModalOpen(false); // Close Personal Info Modal

  return (
    <div className="user-info-container">
      <h2>{t('account.title')}</h2>

      <div className="user-info-email">
        <p>{t('common.emailLabel')}<span className="email-placeholder">
          {loading ? t('common.loading') : email}
        </span></p>
        <p>{t('account.tier')}<span className="tier-placeholder">
          {loading ? t('common.loading') : t(`tiers.${userTier}`, { defaultValue: userTier })}
        </span></p>
      </div>

      {needsAuthSetup && <p className="auth-migration-notice" role="status">{t('authModern.migrationNotice')} <button onClick={openPersonalInfoModal}>{t('account.settings')}</button></p>}

      {/* Button Group */}
      <div className="button-group">
        <button className="manage-org-button" onClick={openModal}>{t('account.organization')}</button>

        <button className="home-page-button" onClick={() => window.open(marketingHomeUrl(i18n.language), '_blank')}>{t('account.homepage')}</button>

        <button className="personal-info-button" onClick={openPersonalInfoModal}>{t('account.settings')}</button>

        <button className="logout-button" onClick={logout}>{t('account.logout')}</button>
      </div>

      {/* Modals */}
      {selectedPlan && <PaymentsModal isOpen tierType={selectedPlan} onClose={() => setSelectedPlan(null)} />}
      {isModalOpen && <OrganizationModal isOpen={isModalOpen} onClose={closeModal} />}
      {isPersonalInfoModalOpen && <PersonalInformationModal googleEnabled={authConfig?.googleEnabled} isOpen={isPersonalInfoModalOpen} onClose={closePersonalInfoModal} />}
    </div>
  );
}

export default UserInfo;
